//src/app/features/questionnaires/components/PreviewExpandable/index.tsx
import { ReactNode } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

export interface IPreviewExpandableProps {
  title: string;
  children: ReactNode;
}

export default function PreviewExpandable(props: IPreviewExpandableProps) {
  const { children, title } = props;
  return (
    <>
      <Accordion
        allowZeroExpanded
        preExpanded={[title.replaceAll(' ', '_')]}
        className="border rounded-lg border-gray-100 mt-2"
      >
        <AccordionItem
          key={title}
          className="w-full"
          uuid={title.replaceAll(' ', '_')}
        >
          <AccordionItemHeading>
            <AccordionItemButton>
              <h2 className="w-full font-semibold">{title}</h2>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>{children}</AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </>
  );
}
